import jwtAuthAxios from "services/jwtAuth";
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

export const letak_kampus_findAll = createAsyncThunk("default/letakKampus_findAll", async (val) => {
    try {
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ] = 'Bearer ' + token;
        const url = `v1/master/pembayaran`
        const response = await jwtAuthAxios.get(url)
        return response.data
    } catch (response) {
        throw response
    }
});

const initialState = {
    loading: false,
    dataLetakKampusAll: [],
}

const defaultSlice = createSlice({
                                         name: "defaults", initialState: initialState, extraReducers: (builder) => {
        builder
            .addCase(letak_kampus_findAll.pending, (state) => {
                state.loading = true;
            })
            .addCase(letak_kampus_findAll.fulfilled, (state, action) => {
                state.dataLetakKampusAll = action.payload;
                state.loading = false;
            })
            .addCase(letak_kampus_findAll.rejected, (state, action) => {
                state.loading = false;
            })
        ;
    }
                                     })
export const defaultSelectors = (state) => state.defaults;
export default defaultSlice.reducer;